<template>
  <div>
    <v-container>
      <v-row style="display: flex; justify-content: center" class="mt-10">
        <v-slide-group v-model="model" class="pa-4" center-active>
          <v-slide-item
            v-for="item in ItemCards"
            :key="item.ID"
            v-slot="{ active }"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                :color="'grey lighten-1'"
                class="ma-4 zoom"
                width="330"
                height="450"
                :elevation="hover ? 8 : 2">
                <v-img
                :src="item.src"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="370px"
                ></v-img>
                <v-card-title
                    class="justify-center"
                    style="font-size: 22px"
                    v-text="item.planName"
                  ></v-card-title>
                <v-card-subtitle 
                    class="justify-center"
                    style="font-size: 16px"
                    v-text="item.description"></v-card-subtitle>
              </v-card>
              <!-- <v-card
                :color="active ? 'grey lighten-1' : 'grey lighten-1'"
                class="ma-4 zoom"
                width="330"
                height="450"
                :elevation="hover ? 8 : 2"
              >
                <v-img
                  :src="item.src"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="450px"
                >
                  <v-card-title
                    class="justify-center"
                    style="font-size: 22px"
                    v-text="item.planName"
                  ></v-card-title>
                </v-img>
              </v-card> -->
            </v-hover>
          </v-slide-item>
        </v-slide-group>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { eventBus } from "../main";
export default {
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      username: localStorage.getItem("Username"),
      fullname: this.$cookies.get("FullName"),
      model: null,
      ItemCards: [],
    };
  },

  mounted() {
    let self = this;
    self.getDataMasterPlan();
  },

  watch: {},

  methods: {
    getDataMasterPlan() {
      let self = this;
      self.LoadingDialog = true;
      axios
        .get(`${self.url}Permission/getDataMasterPlan`)
        .then(function (response) {
          if (response.data.status == 0) {
            // console.log(response.data.data);
            self.ItemCards = response.data.data;
            self.ItemCards.forEach((element) => {
              if (element.id == 1) {
                element.src = require("@/assets/LogoFineday.png");
                element.flex = 3;
              }
              if (element.id == 2) {
                element.src = require("@/assets/LogoFineday.png");
                element.flex = 3;
              }
              if (element.id == 3) {
                element.src = require("@/assets/LogoFineday.png");
                element.flex = 3;
              }
            });
          }
          if (response.data.status == 2) {
            eventBus.$emit("logout");
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          if (error.response.status != 404) {
            Swal.fire({
              icon: "error",
              title: "Error...",
              width: 900,
              text: error.response.data.message,
            });
          }
          eventBus.$emit("logout");
        });
    },
  },
};
</script>
<style>
</style>